import * as React from 'react';
import classnames from 'classnames';

export default class Pagination extends React.Component<any> {
    pagination = (c: number, m: number): string[] => {
        const current = c;
        const last = m;
        const delta = 1;
        const left = current - delta;
        const right = current + delta + 1;
        const range = [];
        const rangeWithDots = [];
        let l;

        for (let i = 1; i <= last; i++) {
            if (i == 1 || i == last || (i >= left && i < right)) {
                range.push(i);
            }
        }

        for (const i of range) {
            if (l) {
                if (i - l === 2) {
                    rangeWithDots.push(l + 1);
                } else if (i - l !== 1) {
                    rangeWithDots.push('...');
                }
            }
            rangeWithDots.push(i);
            l = i;
        }
        return rangeWithDots;
    };

    render() {
        const props = this.props;
        const { pageSize, pageSizeOptions, page, canPrevious, canNext } = props;
        const { onPageChange, onPageSizeChange } = props;
        const totalPages = props.pages;
        const pages: string[] = this.pagination(page + 1, totalPages);

        return (
            <div className="rt-pagination">
                <div className="rt-pagination__page-size">
                    <label htmlFor="page-size--select">
                        <span>Per page: </span>
                        <select
                            id="page-size--select"
                            name="page-size--select"
                            value={pageSize}
                            onChange={(e) => onPageSizeChange(e.target.value)}
                        >
                            {pageSizeOptions.map((value, index) => {
                                return (
                                    <option key={index} value={value}>
                                        {value}
                                    </option>
                                );
                            })}
                        </select>
                    </label>
                </div>
                {canPrevious ? (
                    <div
                        className="rt-pagination__prev-button"
                        onClick={() => {
                            onPageChange(+page - 1);
                        }}
                    >
                        <i className="nx nx-arrow-d" />
                    </div>
                ) : (
                    <div className="rt-pagination__prev-button disabled">
                        <i className="nx nx-arrow-d" />
                    </div>
                )}
                <div className="rt-pagination__pages">
                    {pages.map((value, index) => {
                        const isActive = page + 1 === +value;
                        if (value === '...') {
                            return (
                                <span
                                    className="rt-pagination__page-no"
                                    key={index}
                                >
                                    {' '}
                                    {value}{' '}
                                </span>
                            );
                        } else {
                            return (
                                <span
                                    key={index}
                                    className={classnames(
                                        'rt-pagination__page-no',
                                        { active: isActive }
                                    )}
                                    onClick={() => {
                                        onPageChange(+value - 1);
                                    }}
                                >
                                    {value}
                                </span>
                            );
                        }
                    })}
                </div>
                {canNext ? (
                    <div
                        className="rt-pagination__next-button"
                        onClick={() => {
                            onPageChange(+page + 1);
                        }}
                    >
                        <i className="nx nx-arrow-d" />
                    </div>
                ) : (
                    <div className="rt-pagination__next-button disabled">
                        <i className="nx nx-arrow-d" />
                    </div>
                )}
            </div>
        );
    }
}
